import {Icon} from '@/app/components/Icon';
import {useRef, useState} from 'react';
import {Link, useNavigate, useSearchParams} from 'react-router-dom';
import {InputGroup} from '@/components/app/input-group';
import {InputAdornment} from '@/components/app/input-group';
import {AuthLayout} from '../components/AuthLayout';
import {Form} from '../../../app/components/Form';
import {useLoginMutation} from '../../../app/services/identitiesApi';
import {emailRegExp, getErrorMessage} from '../../../app/utils/miscUtils';
import {getInitialRedirectPath} from '../helpers';
interface FieldValues {
  password: string;
  username: string;
}
export const Login = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [login] = useLoginMutation();
  const form = useRef<Form<FieldValues>>(null);
  const returnUrl = searchParams.get('returnUrl');
  const [error, setError] = useState<string | null>(null);
  return (
    <AuthLayout
      renderContent={() => (
        <Form<FieldValues>
          className={'w-full'}
          fields={[
            {
              label: 'Email',
              labelClassName: 'sr-only',
              name: 'username',
              rules: {
                pattern: {
                  value: emailRegExp,
                  message: 'Invalid email address. E.g. example@email.com',
                },
                required: 'Email is required.',
              },
              type: 'email',
              typeOptions: {
                autoFocus: true,
                className: 'h-[3rem]',
                placeholder: 'Email',
              },
            },
            {
              label: 'Password',
              labelClassName: 'sr-only',
              name: 'password',
              rules: {
                required: 'Password is required.',
              },
              type: 'password',
              typeOptions: {
                feedback: false,
                id: 'password',
                inputClassName: 'h-[3rem]',
                placeholder: 'Password',
                toggleMask: true,
              },
            },
          ]}
          onSubmit={(fieldValues) =>
            login(fieldValues)
              .unwrap()
              .then((result) => {
                navigate(getInitialRedirectPath(result.token, returnUrl));
              })
              .catch((e) => {
                form.current?.setValue('password', '');
                setError(getErrorMessage(e));
                return Promise.reject(e);
              })
          }
          ref={form}
          render={({renderError, renderFieldByName, renderSubmitButton}) => (
            <div className={'flex flex-col gap-4 w-full'}>
              {renderError()}
              <InputGroup position="left" className="[--input-group-height:3rem]">
                <Icon icon="envelope" />
                {renderFieldByName('username')}
              </InputGroup>
              <InputGroup position="left" className="[--input-group-height:3rem]">
                <div>{renderFieldByName('password')}</div>
                <Icon icon="lock" />
              </InputGroup>
              {renderSubmitButton()}
              <Link className="inline-block ml-auto mr-4" to="/reset-password">
                Forgot your password?
              </Link>
              <div className={'mt-4'}>
                <hr className={'border-gray-500'} />
                <div className={'text-center mt-4'}>
                  <span className={'text-muted-foreground'}>Don't have an account?</span>{' '}
                  <Link to={'/sign-up'}>Sign Up</Link>
                </div>
              </div>
            </div>
          )}
          submitButton={{
            className: 'h-[3rem]',
            children: 'Log in',
          }}
        />
      )}
      subtitle={error ? '' : 'Welcome back!'}
      title={'Log in'}
    />
  );
};
